import React, { useRef, useState, useEffect } from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import PanelWrapper from "./PanelWrapper";
import { GridLayout } from "react-grid-layout";
import { useTheme } from "../../context/ThemeContext";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Dashboard.css";

const DashboardGrid = ({
  panels,
  refreshKey,
  timeRange,
  variables,
  onAddPanel,
  onEditPanel,
  onDeletePanel,
  onDuplicatePanel,
  onUpdatePanelData,
  onSetPanelLoading,
  onSetPanelError,
  onLayoutChange,
}) => {
  const { isDark } = useTheme();
  const containerRef = useRef(null);
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const layout = panels.map((panel) => ({
    i: panel.id.toString(),
    x: panel.gridPos?.x || 0,
    y: panel.gridPos?.y || 0,
    w: panel.gridPos?.w || 4,
    h: panel.gridPos?.h || 3,
    minW: 2,
    minH: 2,
    resizeHandles: ['se', 'sw', 'ne', 'nw', 's', 'w', 'e', 'n'],
  }));

  const handleLayoutChange = (newLayout) => {
    if (onLayoutChange) {
      onLayoutChange(newLayout);
    }
  };

  return (
    <div 
      ref={containerRef}
      style={{ 
        padding: "12px",
        background: isDark ? '#0d1117' : '#f5f5f5',
        minHeight: '100%'
      }}
    >
      <GridLayout
        className="layout"
        layout={layout}
        cols={24}
        rowHeight={30}
        width={width}
        margin={[12, 12]}
        containerPadding={[0, 0]}
        onLayoutChange={handleLayoutChange}
        draggableHandle=".panel-drag-handle"
        isDraggable={true}
        isResizable={true}
        compactType="vertical"
      >
        {panels.map((panel) => (
          <div key={panel.id.toString()}>
            <PanelWrapper
              panel={panel}
              refreshKey={refreshKey}
              timeRange={timeRange}
              variables={variables}
              onEdit={onEditPanel}
              onDelete={onDeletePanel}
              onDuplicate={onDuplicatePanel}
              onDataUpdate={onUpdatePanelData}
              onLoading={onSetPanelLoading}
              onError={onSetPanelError}
            />
          </div>
        ))}
      </GridLayout>

      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={onAddPanel}
        style={{ 
          width: "100%", 
          height: 36, 
          marginTop: 12, 
          borderRadius: 4,
          background: isDark ? '#161b22' : '#fff',
          borderColor: isDark ? '#30363d' : '#d9d9d9',
          color: isDark ? '#8b949e' : '#595959',
          fontSize: 13,
          fontWeight: 400
        }}
      >
        Add panel
      </Button>
    </div>
  );
};

export default DashboardGrid;
